export const RESULT_KEYS = {
  sales_exists: 'Vendas já existentes',
  sales_added: 'Vendas adicionadas',
  product_not_exists: 'Produtos não encontrados',
  product_without_campaign: 'Produtos sem campanha',
  empty_invoice_coupon: 'Sem cupom de NF',
  unit_added: 'Unidades cadastradas',
  seller_added: 'Vendedores cadastrados',
  submanager_added: 'Subgerentes cadastrados',
  manager_added: 'Gerentes cadastrados',
  regional_manager_added: 'Gerentes Regionais cadastrados',
  regional_supervisor_added: 'Supervisores Regionais cadastrados',
};
